<template>
	<CharacteristicEdit
		v-model="functions"
		ref="edit"
		:title-formats="{
			default: 'Welche Bereiche in %characteristicLabel%?',
			level: {
				1: 'Welche Tätigkeiten und Aufgaben möchtest du?'
			}
		}"
		with-keyword
		keyword-placeholder="Tätigkeit, Aufgabenbereich eingeben (mind. 3 Zeichen)"
		:characteristic-items="characteristicItems"
		:characteristic-type="meta.functionType"
		:supplements-config="{
			nothingAllowed: true,
			types: supplementTypes
		}"
		:nothing-allowed="{
			overall: nothingAllowedOverall,
			minimumLevel: 2
		}"
		:selected-items-config="{
			noChildrenAppendix: 'Alle Tätigkeiten möglich'
		}"
		:search-config="{ catalog: meta.searchCatalogFunction }"
		open-fan-label="Tätigkeiten auswählen"
		label-type="application"
		:with-edit-button="withEditButton"
		@input="$emit('input', $event)"
	/>
</template>

<script>
import CharacteristicEdit from "@/vue/characteristic/Edit.vue";
import {mapState} from "vuex";
import * as Functions from "@/helper/characteristic/Functions"
import {RELEVANT_SUPPLEMENT_TYPES} from "@/helper/characteristic/Functions";

export default {

	components: {
		CharacteristicEdit
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		employmentModes: {
			type: Array,
			required: true,
		},
		withEditButton: {
			type: Boolean,
			required: false,
			default: true,
		}
	},

	data ()
	{
		return {
			functions: this.value
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		characteristicItems ()
		{
			return this.meta.function;
		},
		nothingAllowedOverall ()
		{
			if (Functions.isNothingAllowedEligible(this.employmentModes))
			{
				return {
					text: 'Alle Tätigkeiten möglich',
					inFan: true
				};
			}

			return undefined;
		},
		supplementTypes ()
		{
			return RELEVANT_SUPPLEMENT_TYPES;
		}
	},

	methods: {
		edit ()
		{
			this.$refs.edit.openFan();
		}
	}
}
</script>
